import React, { Component } from 'react'
import { ReferralMbo } from '../../variables/Config'
import YSpinner from '../../elements/Spinner/Spinner'


class FamilyReferralDeleteButton extends Component {
    constructor(props){
        super(props)
        this._isMounted = false

        this.state = { 
            restError: "",
            isPosting: false // while deleting referral from DB
          }
        this.handleDelete = this.handleDelete.bind(this)
    }
    componentDidMount(){
        this._isMounted =true
    }
    componentWillUnmount(){
        this._isMounted = false
    }
    handleDelete(event) {
        //console.log('handleDelete EVENT', event)
        event.preventDefault();
        const pid = this.props.postid
        //alert('handleDelete: pid= ' + pid)
        //console.log('handleDelete', pid)
        //var uri_ep = "http://yahav/wp-json/mbo/v3/referrals"
        const uri_ep = ReferralMbo()  // uri_ep = "http://yahav/wp-json/mbo/v3/referrals"
        this.setState({isPosting: true})
        // alert("מתחיל מחיקה")

        fetch(uri_ep, {
            method: 'DELETE',
            headers: { 
                //'Access-Control-Allow-Origin':'http://localhost:3000', 
                //'Accept': 'application/json', 'Authorization': 'Basic '+btoa('meital:@site2goal.')
                'Accept': 'application/json', 'Authorization': 'Bearer' + this.props.mbouser.token
            },
            body: JSON.stringify({pid}) 
        }).then(response => {
            if (response.ok) {
                // alert("המידע נמחק מהמאגר")
                if (!this._isMounted) return null
                // this.setState({isPosting:false})
                // console.log("got ok from fetch delete", response.json())
                this.setState({isPosting: false})
                return response.json()
            } else {
                this.setState({isPosting: false})
                throw new Error('Something went wrong on fetch DELETE ... ', pid)
            }
        }).catch(restError => this.setState({ restError: restError}))
        this.props.removeReferral(pid)
    }

    render() { 
        const buttonStyle = {marginRight: '0'}  
        // <input type="submit" style={{width:'150px'}} onClick={this.handleDelete /*.bind(this, this.props.postid)*/ } value="מחיקת הפניה" />
        if (this.state.isPosting)
            return (<YSpinner op={'delete'} />)
            // return (<h3>מוחק... ספינר</h3>)
        return (   
            <button style={buttonStyle} type="button" className="btn btn-success pull-left" onClick={this.handleDelete} >
        מחיקת הפניה
    </button>     
            )
    }
}

export default FamilyReferralDeleteButton ;
